module.exports = __webpack_public_path__ + "img/instructionImage.56dd4bf9.png";